(function() {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    /**
     * Configures $httpProvider with authentication interceptors. Automatically configured by requiring ihh-utilities from another
     * AngularJS module, as shown in the example below.
     * @example
     * angular.module('myModule', ['ihh-utilities', ...]);
     * @ngdoc service
     * @name Authentication
     * @memberOf ihh-utilities
     */

    angular
        .module('ihh-common-web')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$q', '$rootScope', 'AUTH_EVENTS'];

    /**
     * Intercepts any 401 (Unauthorized) HTTP responses, and broadcasts the
     * notAuthorized event to let apps do specific logic.
     * @memberOf ihh-utilities
     * @name authInterceptor
     */
    function authInterceptor($q, $rootScope, AUTH_EVENTS) {
        return {
            response: function(response) {
                return response || $q.when(response);
            },
            responseError: function(rejection) {
                if (rejection.status === 401) {
                    $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
                }
                else if (rejection.status === 403) {
                    $rootScope.$broadcast(AUTH_EVENTS.forbidden);
                }

                return $q.reject(rejection);
            }
        };
    }
})();